import React from "react";
import "./organisationCard.css";
import { Organisation } from "../../features/organisation/organisationTypes";
import OrganisationMobileModal from "./modal/organisationModalMobile";
import OrganisationModal from "./modal/organisationModal";
import OrganisationServiceTypeInfo from "./organisationServiceTypeInfo";
import OrganisationContactInfo from "./organisationContactInfo";
import { reportCardDisplayed } from "../../services/utmService";
import { ColumnFlexBox } from "../common/FlexBoxes";
import { Button, Heading5, Icon, ParagraphSmall, useBreakpoint, Modal } from "@tal-gel/components-v2";

interface propsFromComponent {
  item: Organisation;
}

type Props = propsFromComponent;

const OrganisationCard: React.FC<Props> = ({ item }) => {
  const [organisationModalVisible, setOrganisationModalVisible] = React.useState(false);
  const isMdScreenSize = useBreakpoint("md");

  const openModal = () => {
    if (!organisationModalVisible) {
      setOrganisationModalVisible(true);
      reportCardDisplayed(item.externalName);
    }
  };

  return (
    <div className="card" onClick={() => openModal()}>
      <ColumnFlexBox style={{ gap: "24px", height: "auto" }}>
        <Heading5>{item.externalName}</Heading5>
        <ParagraphSmall>{item.description}</ParagraphSmall>

        <ColumnFlexBox style={{ alignItems: "flex-start" }}>
          <OrganisationContactInfo item={item} />
          <OrganisationServiceTypeInfo item={item} />
          <Button variant="secondary" size="small" iconLeft={<Icon name="Plus" />}>
            View Additional Info
          </Button>
        </ColumnFlexBox>
        <Modal
          isOpen={organisationModalVisible}
          title={<Heading5>{item.externalName}</Heading5>}
          onOpenChange={setOrganisationModalVisible}
          size={"large"}
          closeButton="show"
          fullscreen="never"
        >
          {isMdScreenSize ? <OrganisationModal item={item} /> : <OrganisationMobileModal item={item} />}
        </Modal>
      </ColumnFlexBox>
    </div>
  );
};

export default OrganisationCard;
